<template>
	<div>
		<header id="header" class="" width="100vw">

			<div :style="'background-color:' + bgcolor1" style="border-bottom: 1px solid #eee;">
      <!-- <div style="background-color:#fff;border-bottom: 1px solid #eee;"> -->
				<div class="container">
          <!-- 右侧文字 -->
          <!-- <div :style="'color:' + fontColor2" >{{ title2 }}</div> -->
          <div style="color: #000;font-size: 18px;height: 65px;line-height: 65px;float: left;
          padding:5px 0;margin: 10px 0;">
          <!-- {{ title2 }} -->
          <a class="navbar-brand" style="float: left;">
          <img style="border-radius: 50%;" :src="logoUrl"/>
          </a>
          <div style="float: left;font-size: 24px;font-weight: bolder;line-height: 58px;"
          :class="{ style1: tab_type != '1' }" :style="'color:' + fontColor1">{{ title1 }}</div>
          </div>
          <!-- 左侧登录 -->
          <div class="cont_box" style="float: right;">

          	<a class="cont_center cont_col1" @click="open_qdao()">
          		<div style="margin-left: 20px; cursor: pointer;color: #000;font-size: 16px;">签到</div>
          	</a>
            <div class="cont_center cont_col3" v-if="empower.taskedAble==1 || empower.centerAble==1 || empower.workAble==1">

            	<el-dropdown trigger="click">
            		<div class="el-dropdown-link">
            			<span>应用中心</span>
            		</div>
            		<el-dropdown-menu slot="dropdown" class="cont_pos cont_center_column"
                style="background:url(/static/Upload/top_bg_menu.png) no-repeat;
                background-size: 100% 100%;
                padding: 10px 0 10px 0;background-color: #fff;width: 110px;">
                  <el-dropdown-item v-if="empower.workAble==1" style="margin: 0; padding: 0 20px;"
                	@click.native="open_type(12)">作业中心</el-dropdown-item>
            			<el-dropdown-item v-if="empower.taskedAble==1" style="margin: 0; padding: 0 20px"
            				@click.native="open_type(5)">实践中心</el-dropdown-item>
            			<el-dropdown-item style="margin: 0; padding: 0 20px;"
                  v-if="empower.centerAble==1 && (isLeader == 1 || role == 2)"
            				@click.native="open_news(4)">课程中心</el-dropdown-item>
                    <el-dropdown-item style="margin-top:5px; padding: 0 20px;
                    border-top: 1px solid #ddd;" v-if="is_pingjia==1 && role > 0"
                    	@click.native="open_pingjia()">评价中心</el-dropdown-item>
                  <el-dropdown-item style="margin-top:5px; padding: 0 20px;
                  border-top: 1px solid #ddd;" v-if="isLeader == 1"
                  	@click.native="open_statistics()">统计分析</el-dropdown-item>


            		</el-dropdown-menu>
            	</el-dropdown>
            </div>
            <a class="cont_center cont_col2" @click="open_login()" v-if="!token">
            	<div style="margin-left: 20px;font-size: 16px;">登录</div>
            </a>
            <div class="cont_center cont_col3" v-else>
            	<el-dropdown trigger="click">
            		<div class="el-dropdown-link">
                  <!-- 消息 -->
                   <img @click="si_message" src="/static/Upload/si_message.png" style="width: 25px;height:25px;"/>
            			<!-- <img :src="avatar" class="head_img" /> -->

            			<span>{{ isLeader == 0 ? (role == 1 ? "学生：" : "教师：") : '院校领导：' }}{{ name }}
            			</span>

            		</div>
            		<el-dropdown-menu slot="dropdown" class="cont_pos cont_center_column"
                style="background:url(/static/Upload/top_bg_menu.png) no-repeat;
                background-size: 100% 100%;
                padding: 10px 0 10px 0;background-color: #fff;width: 110px;">

            			<el-dropdown-item style="margin: 0; padding: 0 20px"
            				@click.native="open_news(0)">个人信息</el-dropdown-item>
                  <el-dropdown-item v-if="role==2" style="margin: 0; padding: 0 20px"
                  	@click.native="open_news(1)">个人积分</el-dropdown-item>
            			<el-dropdown-item style="margin: 0; padding: 0 20px"
            				@click.native="open_news(2)">修改密码</el-dropdown-item>
            			<el-dropdown-item style="margin: 0; padding: 0 20px;"
            				@click.native="open_news(3)">帮助信息</el-dropdown-item>
            			<!--                  <el-dropdown-item style="margin:0;padding: 0 20px;" v-if="role == 1">我的成绩</el-dropdown-item>-->
            			<el-dropdown-item style="margin: 0; padding: 0 20px;border-top: 1px solid #ddd;"
            				@click.native="open_logout()">退出登录</el-dropdown-item>
            		</el-dropdown-menu>
            	</el-dropdown>

            </div>
          </div>

				</div>
			</div>
			<nav id="main-menu" class="navbar navbar-default" :class="{ back_active: tab_type == '1' }"
				style="">
				<div class="container">
					<div class="navbar-collapse navbar-center collapse cont_between">
						<div>
							<ul class="nav navbar-nav cont_center1" >
								<!--                <li class="scroll" :class="{active:tab_type == item.id}" v-for="(item,index) in list" @click="open_type(item.id)" :key="index">{{item.name}}</li>-->
								<li class="scroll" @click="open_type('1')">
									首页
								</li>
								<li v-if="empower.voviAble==1" class="scroll" :class="{ active: tab_type == '2' }">
									<div class="xiala cont_center1">
										<div @click="open_type1('1x')">全景思政</div>
										<!-- <div class="xisls cont_center_column">
											<div class="cont_center1" @click="open_type1('1')">
												序言
											</div>
											<div class="cont_center1" @click="open_type1('2')">
												分类列表
											</div>
										</div> -->
									</div>
								</li>
								<li v-if="empower.vrAble==1" class="scroll" :class="{ active: tab_type == '3' }">
									<div class="xiala cont_center1">
										<div @click="open_type2('2x')">
											VR思政
										</div>
										<!-- <div class="xisls cont_center_column">
											<div class="cont_center1" @click="open_type2(1)">
												序言
											</div>
											<div class="cont_center1" @click="open_type2(2)">
												分类列表
											</div>
										</div> -->
									</div>
								</li>

								<li v-if="empower.mindAble==1" class="scroll" :class="{ active: tab_type == '7' }">
									<div class="xiala cont_center1">
										<div @click="open_type('7')">精神谱系</div>
										<!-- <div class="xisls cont_center_column">
											<div class="cont_center1" @click="open_type7('1')">
												序言
											</div>
											<div class="cont_center1" @click="open_type7('2')">
												分类列表
											</div>
										</div> -->
									</div>
								</li>
                <li v-if="empower.movieAble==1" class="scroll" :class="{ active: tab_type == '11' }">
                	<div class="xiala cont_center1">
                		<div @click="open_type3('3')">影视资源</div>
                		<!-- <div class="xisls cont_center_column">
                			<div class="cont_center1" @click="open_type3xx('1')">
                				序言
                			</div>
                			<div class="cont_center1" @click="open_type3xx('2')">
                				分类列表
                			</div>
                		</div> -->
                	</div>
                </li>

								<li v-if="empower.mindClazzAble==1" class="scroll" :class="{ active: tab_type == '9' }">
									<div class="xiala cont_center1">
										<div @click="open_type3('8')">思政课程</div>
										<!-- <div class="xisls cont_center_column">
											<div class="cont_center1" @click="open_type3x('1')">
												序言
											</div>
											<div class="cont_center1" @click="open_type3x('2')">
												分类列表
											</div>
										</div> -->
									</div>
								</li>
                <!-- v-if="role == 2" -->
                <!-- 仅仅海南不需要，其他平台正常打开 -->
								<!-- <li class="scroll" :class="{ active: tab_type == '10' }">
									<div class="xiala cont_center1">
										<div @click="open_type3('2')">课程思政</div>
										<div class="xisls cont_center_column">
										</div>
									</div>
								</li> -->
                <!-- end -->

								<!-- <li class="scroll" :class="{ active: tab_type == '9' }" @click="open_type('9')">
									作业中心
								</li>

								<li class="scroll" :class="{ active: tab_type == '5' }" @click="open_type('5')">
									实践中心
								</li> -->


								<li class="scroll" :class="{ active: tab_type == '6' }">
									<div class="xiala cont_center1">
										<div @click="open_type4('4x')">方针政策</div>
										<!-- <div class="xisls cont_center_column">
											<div class="cont_center1" @click="open_type4('2')">
												国家方针
											</div>
											<div class="cont_center1" @click="open_type4('1')">
												部委政策
											</div>
										</div> -->
									</div>
								</li>
							</ul>
              <div style="clear: both;"></div>
						</div>

					</div>
				</div>
			</nav>
		</header>
		<!--    签到-->
		<div class="cont_mb" v-if="show_login1" :style="{ height: clientHeight + 'px' }"></div>
		<div class="cont_login2" v-if="show_login1" style="width: 1000px">
			<div class="cont_text1 cont_center1">
				<div class="cont_center_column">
					<img src="/static/Upload/wrong_icon.png" class="wrong1_icon" @click="open_show()" />
					<img src="/static/Upload/back_icon.png" class="back_icon" />
					<div class="cont_qd">
						<h5 style="
                color: #fff;
                font-size: 18px;
                font-weight: 600;
                letter-spacing: 2px;
              ">
							{{ monthCurrent }}月份签到记录
						</h5>
						<div class="cont_box1" style="display: flex;justify-content: space-between;">
              <div class="" style="border: 1px solid #FFDFB6;border-radius: 50%;margin-left: -10px;">
                <b style="width: 35px;height: 35px;background:#FFDFB6;color: #B31711;
                border-radius: 50%;margin: 5px;text-align: center;
                line-height: 35px;display: block;">今</b>
              </div>
              <div class="" style="border: 1px solid #FFDFB6;border-radius: 50%;margin-left: -10px;">
                <b style="width: 35px;height: 35px;background:#FFDFB6;color: #B31711;
                border-radius: 50%;margin: 5px;text-align: center;
                line-height: 35px;display: block;">月</b>
              </div>
              <div class="" style="border: 1px solid #FFDFB6;border-radius: 50%;margin-left: -10px;">
                <b style="width: 35px;height: 35px;background:#FFDFB6;color: #B31711;
                border-radius: 50%;margin: 5px;text-align: center;
                line-height: 35px;display: block;">已</b>
              </div>
              <div class="" style="border: 1px solid #FFDFB6;border-radius: 50%;margin-left: -10px;">
                <b style="width: 35px;height: 35px;background:#FFDFB6;color: #B31711;
                border-radius: 50%;margin: 5px;text-align: center;
                line-height: 35px;display: block;">签</b>
              </div>
              <div class="" style="border: 1px solid #FFDFB6;border-radius: 50%;margin-left: -10px;">
                <b style="width: 35px;height: 35px;background:#FFDFB6;color: #B31711;
                border-radius: 50%;margin: 5px;text-align: center;
                line-height: 35px;display: block;">到</b>
              </div>
              <div class="" style="border: 1px solid #FFDFB6;border-radius: 50%;margin-left: -10px;">
                <b style="width: 35px;height: 35px;background:#FFDFB6;color: #B31711;
                border-radius: 50%;margin: 5px;text-align: center;
                line-height: 35px;display: block;">{{ signined.length }}</b>
              </div>
              <div class="" style="border: 1px solid #FFDFB6;border-radius: 50%;margin-left: -10px;">
                <b style="width: 35px;height: 35px;background:#FFDFB6;color: #B31711;
                border-radius: 50%;margin: 5px;text-align: center;
                line-height: 35px;display: block;">天</b>
              </div>

						</div>
					</div>
				</div>

				<div class="cont_one cont_center">
					<div style="cursor: pointer;" class="cont_day cont_center_column" v-for="(item, index) in date_day3"
						:key="index" :class="{
              active: item.issign,
              currentDay: currentDay == index + 1
            }" @click="open_day(item, index)">
						<span>{{ monthCurrent }}月{{ index + 1 }}日</span>
						<img v-if="item.issign == true ? 'active' : ''" src="/static/Upload/duihao_icon.png"
							class="duihao_icon" />
						<img v-else src="/static/Upload/xing_icon.png" class="xing_icon" />
						<span v-if="item.issign == true ? 'active' : ''">已签到</span>
						<span v-else>未签到</span>
						<!--              </div>-->
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Bus from "../router/bus.js";
	export default {
		name: "Head",
		// 监听,当路由发生变化的时候执行
		watch: {
			$route: {
				handler: function(val, oldVal) {
					this.tab_type = val.query.tab_type;
				},
				// 深度观察监听
				deep: true
			}
		},
		data() {
			return {
				monthCurrent: new Date().getMonth() + 1, // 当前月份
				tab_type: "1",
				empower: [],
				avatar: localStorage.getItem("avatar"),
				detail_name: "",
				clientHeight: "",
				detail_content: "",
				date_day3: [],
				date_day_type: "",
				list_Vr: [], // vr体验下拉列表
				show_login: false,
				show_login1: false,
				role: window.localStorage.getItem("role"),
				isLeader: window.localStorage.getItem("isLeader"),
				name: window.localStorage.getItem("name"),
				token: window.localStorage.getItem("token"),
				dateCurrent: new Date().getDate(), // 当前月份第几天
				title1: "",
				title2: "",
				logoUrl: "",
				bgcolor1: "",
				fontColor1: "",
				fontColor2: "",
				currentDay: new Date().getDate(),
				list_Vr_menu_Top: [],
				listVrMenuPageTop: 0,
				menu_max_size: 6,
        is_pingjia:0
			};
		},
		inject: ["reload"],
		methods: {
			getList_Vr_menu_Top() {
				let that = this;
				let i;
				that.list_Vr_menu_Top = [];
				for (i = 0; i < that.menu_max_size; i++) {
					that.list_Vr_menu_Top.push(that.list_Vr[i]);
				}
			},
			changeListVrTop(type) {
				let that = this;
				if (type == 1) {
					if (that.list_Vr_menu_Top[0].id == that.list_Vr[0].id) {
						that.listVrMenuPageTop = 0;
					} else {
						that.list_Vr.forEach((item, index) => {
							// 执行代码
							if (item.id == that.list_Vr_menu_Top[0].id) {
								that.listVrMenuPageTop = index;
							}
						});
						console.log(that.listVrMenuPageTop);
						that.list_Vr_menu_Top.splice(that.list_Vr_menu_Top.length - 1, 1);
						that.list_Vr_menu_Top.unshift(
							that.list_Vr[that.listVrMenuPageTop - 1]
						);
						console.log(that.list_Vr[that.listVrMenuPageTop - 1].name);
					}
				} else if (type == 2) {
					if (
						that.list_Vr_menu_Top[that.list_Vr_menu_Top.length - 1].id ==
						that.list_Vr[that.list_Vr.length - 1].id
					) {
						that.listVrMenuPageTop = that.list_Vr.length - 1;
					} else {
						that.list_Vr.forEach((item, index) => {
							// 执行代码
							if (
								item.id ==
								that.list_Vr_menu_Top[that.list_Vr_menu_Top.length - 1].id
							) {
								that.listVrMenuPageTop = index;
							}
						});
						that.list_Vr_menu_Top.push(that.list_Vr[that.listVrMenuPageTop + 1]);
						that.list_Vr_menu_Top.splice(0, 1);
					}
				}
			},
			// 跳转到思政资源云
			open_type5() {
				// window.location.href = "http://www.sizhengziyuanku.com/";
			},
			// 签到
			open_show() {
				var that = this;
				that.show_login1 = false;
			},
			open_day(obj, index) {
				if (index + 1 != this.dateCurrent) {
					return;
				}
				var that = this;
				that.date_day_type = that.date_day;
				if (that.date_day == that.date_day_type) {
					that.$http.ajax(that.$http.signin, {}, function(res) {
						that.date_day3 = [];
						that.date_num = [];
						that.open_init();
					});
				}
			},
			open_init() {
				let that = this;
				let nowDate = new Date();
				let year = nowDate.getFullYear();
				let month = nowDate.getMonth();
				that.date_day = nowDate.getDate();
				let max = new Date(year, month + 1, 0);
				that.date_day2 = max.getDate();
				that.date_day2 =
					that.date_day2 < 10 ? "0" + that.date_day2 : that.date_day2;
				let str = "";
				let num_str = [];
				for (var i = 1; i <= that.date_day2; i++) {
					str = i;
					that.date_day3.push(
						`${year}-${(month + 1).toString().length == 1 ? "0" : ""}${month +
            1}-${str.toString().length == 1 ? "0" : ""}${str}`
					);
				}
				if (localStorage.getItem("token")) {
					that.$http.ajax(that.$http.getSigninDetail, {}, function(res) {
						that.signined = res.result.signined;
						let str_date = [];
						for (var key = 0; key < that.date_day3.length; key++) {
							let issign = false;
							for (var i in that.signined) {
								if (that.signined[i] == that.date_day3[key]) {
									issign = true;
									// break;
								} else {
									issign = false;
								}
							}
							str_date.push({
								date: that.date_day3[key],
								issign: issign
							});
						}
						that.date_day3 = str_date;
					});
				}
			},
			open_type1(obj) {
				var that = this;
				if (!this.$http.isLogined()) {
					that.token = localStorage.getItem("token");
					Bus.$emit("show_Login", "true");
					return;
				}
				if (obj == "1x") {
					that.reload();
					that.$router.push({
						path: "/panorama",
						query: {
							tab_type: 2,
							type: 1
						}
					});
					window.localStorage.setItem("tab_type", 2);
					return;
				}
				that.tab_type = obj;
				that.reload();
				that.$router.push({
					path: "/panorama",
					query: {
						tab_type: 2,
						type: that.tab_type
					}
				});
				window.localStorage.setItem("tab_type", 2);
			},
			open_type2(obj) {
				var that = this;
				if (!this.$http.isLogined()) {
					that.token = localStorage.getItem("token");
					Bus.$emit("show_Login", "true");
					return;
				}
				if (obj == "2x") {
					that.reload();
					that.$router.push({
						path: "/vr",
						query: {
							tab_type: 3,
							type: 1
						}
					});
					// window.localStorage.setItem("tab_type", 3);
					return;
				}

				that.tab_type = obj;
				that.reload();
				that.$router.push({
					path: "/vr",
					query: {
						tab_type: 3,
						type: that.tab_type
					}
				});
				window.localStorage.setItem("tab_type", 3);
			},
			open_type3(obj) {
        var that = this
				if (obj == 2) {
          if (!this.$http.isLogined()) {
          	that.token = localStorage.getItem("token");
          	Bus.$emit("show_Login", "true");
          	return;
          }
					if (window.localStorage.getItem("role") == 2) {

						that.$http.ajax(that.$http.getclazzMindDomain, {}, function(res) {
							// window.location.href = res.result
              window.open(res.result,'_target')
						});
					} else {
						that.$message({
							type: "success",
							message: "即将开放",
							offset: 180
						});
						return
					}
				}
				if (!this.$http.isLogined()) {
					that.token = localStorage.getItem("token");
					Bus.$emit("show_Login", "true");
					return;
				}

				if (obj == 1) {
					that.reload();
					that.$router.push({
						// path: "/quan_sz",
						path: "/Teachingresources",
						query: {
							tab_type: 9,
							data_id: obj
						}
					});
				}
        if (obj == 8) {
        	that.reload();
        	that.$router.push({
        		// path: "/quan_sz",
        		path: "/Teachingresources",
        		query: {
        			tab_type: 9,
        			data_id: 1,
              type:1
        		}
        	});
        }
				if (obj == 3) {
					console.log('????', obj)
					that.reload();
					that.$router.push({
						// path: "/quan_sz",
						path: "/Teachingresources",
						query: {
							tab_type: 11,
							data_id: 1,
              type:1,
						}
					});
				}
			},
      si_message(){
        var that = this;
        if(that.isLeader==1){
          var type_one = 3
        }else{
          var type_one = 1
        }
        	that.$router.push({
        		path: "/simessage",
        		query: {
        			tab_type: 2,
        		  type_one:type_one,
        		}
        	});
      },
      open_type3x(obj) {

      	var that = this;
      	if (!this.$http.isLogined()) {
      		that.token = localStorage.getItem("token");
      		Bus.$emit("show_Login", "true");
      		return;
      	}

      		that.reload();
      		that.$router.push({
      			// path: "/quan_sz",
      			path: "/Teachingresources",
      			query: {
      				tab_type: 9,
      				data_id: obj,
              type:obj,
      			}
      		});
      },
      open_type3xx(obj) {

      	var that = this;
      	if (!this.$http.isLogined()) {
      		that.token = localStorage.getItem("token");
      		Bus.$emit("show_Login", "true");
      		return;
      	}

      		that.reload();
      		that.$router.push({
      			// path: "/quan_sz",
      			path: "/Teachingresources",
      			query: {
      				tab_type: 11,
      				data_id: obj,
              type:obj,
      			}
      		});
      },
			open_type4(obj) {
				var that = this;
				if (!this.$http.isLogined()) {
					that.token = localStorage.getItem("token");
					Bus.$emit("show_Login", "true");
					return;
				}
				if (obj == "4x") {
					that.reload();
					that.$router.push({
						path: "/quan_sz",
						query: {
							tab_type: 6,
							data_id: 2
						}
					});
					window.localStorage.setItem("tab_type", 6);
					return;
				}

				that.tab_type = obj;
				that.reload();
				that.$router.push({
					path: "/quan_sz",
					query: {
						tab_type: 6,
						data_id: that.tab_type
					}
				});
				window.localStorage.setItem("tab_type", 6);
			},
			open_type7(data) {
				var that = this;
				that.reload();
				that.$router.push({
					path: "/quan_sz",
					query: {
						tab_type: 7,
						data_id: data,
						page_type: 0
					}
				});
				window.localStorage.setItem("tab_type", 7);
			},
			open_type(obj) {
				var that = this;
				that.tab_type = obj;
				if (that.tab_type == 1) {
					that.reload();
					that.$router.push({
						path: "/"
					});
					window.localStorage.setItem("tab_type", 1);
				} else if (that.tab_type == 2) {
					that.reload();
					that.$router.push({
						path: `/quan_sz`,
						query: {
							tab_type: 2
						}
					});
					window.localStorage.setItem("tab_type", 2);
				} else if (that.tab_type == 3) {
					that.reload();
					that.$router.push({
						path: `/quan_sz`,
						query: {
							tab_type: 3,
							data_id: 1
						}
					});
					window.localStorage.setItem("tab_type", 3);
				} else if (that.tab_type == 4) {
					that.reload();
					that.role = window.localStorage.getItem("role");
					if (that.role == 1) {
						that.$router.push({
							path: `/quan_sz`,
							query: {
								tab_type: 4,
								data_id: 3
							}
						});
					} else if (that.role == 2) {
						that.$router.push({
							path: `/quan_sz`,
							query: {
								tab_type: 4,
								data_id: 1
							}
						});
					}
					window.localStorage.setItem("tab_type", 4);
				} else if (that.tab_type == 5) {
					if (!this.$http.isLogined()) {
						that.token = localStorage.getItem("token");
						Bus.$emit("show_Login", "true");
						return;
					}
					that.$router.push({
						path: `/practice`,
						query: {
							tab_type: 5
						}
					});
					window.localStorage.setItem("tab_type", 5);
				} else if (that.tab_type == 6) {
					that.reload();
					that.$router.push({
						path: `/quan_sz`,
						query: {
							tab_type: 6,
							data_id: 1
						}
					});
					window.localStorage.setItem("tab_type", 6);
				} else if (that.tab_type == 7) {
          if (!this.$http.isLogined()) {
          	that.token = localStorage.getItem("token");
          	Bus.$emit("show_Login", "true");
          	return;
          }
					that.reload();
					that.$router.push({
						path: `/quan_sz`,
						query: {
							tab_type: 7,
							data_id: 1,
							page_type: 0
						}
					});
					window.localStorage.setItem("tab_type", 7);
				} else if (that.tab_type == 12) {
					if (!this.$http.isLogined()) {
						that.token = localStorage.getItem("token");
						Bus.$emit("show_Login", "true");
						return;
					}
					that.$router.push({
						path: `/work_center`,
						query: {
							tab_type: 12
						}
					});
					window.localStorage.setItem("tab_type", 12);
				}
			},
			open_news(tys) {
				if (!this.$http.isLogined()) {
					this.token = localStorage.getItem("token");
					Bus.$emit("show_Login", "true");
					return;
				}
        if(tys==4){
          if(this.empower.centerAble!=1){
            this.$router.push({
            	path: `/table_lb_center`,
              query: {
                type_one:1,
              }
            });
          }else{
            this.$router.push({
            	path: `/table_lb_center`,
              query: {
                type_one:1,
              }
            });
          }

          this.reload()
        }else{
          this.$router.push({
          	path: `/table_lb`,
            query: {
              type_one:tys,
            }
          });
          this.reload()
        }

			},
			open_statistics() {

				if (!this.$http.isLogined()) {
					this.token = localStorage.getItem("token");
					Bus.$emit("show_Login", "true");
					return;
				}
				this.$router.push({
					path: `/statistics`
				});
			},
			open_help() {
				let that = this;
				if (!this.$http.isLogined()) {
					that.token = localStorage.getItem("token");
					Bus.$emit("show_Login", "true");
					return;
				}
				that.$http.ajax(that.$http.getHelpTxt, {}, function(res) {
					that.detail_name = res.result.name;
					that.detail_content = res.result.content;
					that.$router.push({
						path: `/detail`,
						query: {
							tab_type: 7,
							detail_name: that.detail_name,
							detail_content: that.detail_content
						}
					});
				});
			},
			open_login() {
				Bus.$emit("show_Login", "true");
			},
			open_passwd() {
				// Bus.$emit("show_Login", "true");
				Bus.$emit("show_modify", "2");
			},
			open_qdao() {
				var that = this;
				if (!this.$http.isLogined()) {
					that.token = localStorage.getItem("token");
					Bus.$emit("show_Login", "true");
					return;
				}
				that.show_login1 = !that.show_login1;
			},
			open_logout() {
				var that = this;
				window.localStorage.removeItem("token");
				window.localStorage.removeItem("role");
				window.localStorage.removeItem("name");
				window.localStorage.removeItem("taskedId");
				window.localStorage.removeItem("taskedName");
				// window.localStorage.removeItem("SiteInfo");
        //清除所有
        // window.localStorage.clear();
				that.$router.push({
					path: `/`
				});
				that.reload();
				that.$http.ajax(that.$http.logout, {}, function(res) {});
			},
			// 获取vr体验列表
			getVrList() {
				let that = this;
				that.$http.ajax(that.$http.getVrTypeInfo, {}, function(data) {
					that.list_Vr = data.result;
					that.getList_Vr_menu_Top();
				});
			},
			// 获取网站信息
			getSiteInfo() {
				let that = this;
				that.$http.ajax(that.$http.getSiteInfo, {}, function(res) {
					that.title1 = res.result.title1;
					that.title2 = res.result.title2;
					that.logoUrl = res.result.logoUrl;
					that.bgcolor1 = res.result.bgcolor1;
					that.fontColor1 = res.result.fontColor1;
					that.fontColor2 = res.result.fontColor2;
					// 将this.pickerItem的数据存储入insuranceCode,需提前转化成string类型
					window.localStorage.setItem("SiteInfo", JSON.stringify(res.result));

				});
			},
      shouquan(){
        let that = this;
        that.$http.ajax(
          that.$http.getColEmpower, {},
        function(res){
          console.log('rrrrr',res)
          that.empower = res.result;
          window.localStorage.setItem('empower', JSON.stringify(res.result))
          // "workAble": 1, //是否支持作业中心  1：是；0：否
          // "cloudFileSizeMax": 100, //每个教师支持的最大空间
          // "cloudFileCountMax": 3, //每个教师支持的最大上传文件数量
          // "mindClazzAble": 1, //是否支持思政课程
          // "voviAble": 1, //是否支持全景
          // "centerAble": 1, //是否支持课程中心
          // "vrAble": 1, //是否支持VR
          // "movieAble": 1, //是否支持影视
          // "taskedAble": 1, //任务中心
          // "mindAble": 1 //精神谱系
        })
      },
      open_pingjia() {
      	let that = this;
      	if (!this.$http.isLogined()) {
      		that.token = localStorage.getItem("token");
      		Bus.$emit("show_Login", "true");
      		return;
      	}
        if(that.role==2){
          that.$router.push({
          	path: `/pingjia`,
          	query: {

          	}
          });
        }else{
          that.$router.push({
          	path: `/stupingjia`,
          	query: {

          	}
          });
        }

      },
      openis_ping(){
        let that = this;
        if (this.$http.isLogined()) {
          that.$http.ajax(that.$http.isAllowRate, {}, function(res) {
            that.is_pingjia = res.result.rateAllow?res.result.rateAllow:0
              console.log('-=--=',res.result.rateAllow)
          	});
        }

      }
		},
		created() {
			this.open_init();
      this.shouquan()
      // this.openis_ping()是否开启评价功能
			this.clientHeight = document.documentElement.clientHeight;
			this.tab_type = window.localStorage.getItem("tab_type");

			// let that = this;
      if(this.empower && this.empower.vrAble==1){
			this.getVrList(); //虚拟仿真
      }

      if(!this.$http.isLogined()){
        this.getSiteInfo();
      }else{
        let that = this
        var SiteInfos = JSON.parse(window.localStorage.getItem("SiteInfo"));

        that.title1 = SiteInfos.title1;
        that.title2 = SiteInfos.title2;
        that.logoUrl = SiteInfos.logoUrl;
        that.bgcolor1 = SiteInfos.bgcolor1;
        that.fontColor1 = SiteInfos.fontColor1;
        that.fontColor2 = SiteInfos.fontColor2;
      }
		},
		mounted() {
			this.tab_type = this.$route.query.tab_type;
			var that = this
			if (that.tab_type == null) {
			  that.tab_type = 1
			}
		}
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  .back_active{
    background:#fff;
    color: #000!important;
  }
	.xiala {
		height: 50px;
	}

	#main-menu * {
		// color: #fff;
	}

	.xiala:hover {
		position: relative;

		.xisls {
			display: block;
			color: #606266;
			font-weight: 500;
		}
	}

	.xisls {
		display: none;
		position: absolute;
		top: 50px;
		left: -34px;

		div {
			width: 130px;
			// background: #ffffff;
			// border-bottom: 1px solid #f1f1f1;
			font-size: 14px;
			padding: 10px 20px;
			border-radius: 3px;
		}
	}

	.xisls div:hover {
		background: #a60e0a !important;
		color: #66b1ff;

		a {
			background-color: #a60e0a !important;
		}
	}

	.currentDay {
		background: #99ccff !important;
		// color: #fff !important;
	}
  .navbar-default{
    color: #000
      }

	.navbar-default .navbar-nav>.active::after {
		display: block;
		content: "";
		position: absolute;
		width: 36px;
		height: 1px;
		// background-color: #fff;
		left: 50%;
		bottom: 8px;
		margin-left: -20px;
	}

	.active {
		color: #e3130b;
		font-weight: 600;
    background:none ;
	}

	.navbar-nav li {
		height: 57px;
		text-align: center;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		justify-content: center;
		cursor: pointer;
	}

	h1,
	h2 {
		font-weight: normal;
	}

	ul {
		list-style-type: none;
		padding: 0;
	}

	li {
		display: inline-block;
		padding: 0 20px;
	}

	a {
		color: #42b983;
	}

	.cont_box {
		height: 50px;
		font-size: 14px;
		display: flex;
		align-items: center;
		// cursor: pointer;
		justify-content: flex-end;
		position: relative;
    margin-top:20px;
	}

	.cont_pos1 {
		width: 150px;
		margin-top: 15px;
		top: 60px !important;
		text-align: center;
	}

	.cont_pos {
		width: 98px;
		margin-top: 20px;
		text-align: center;
		position: absolute;
		/*right: -10px;*/
	}

	.el-dropdown-menu__item {
		width: 100% !important;
	}

	.scroll {
		position: relative;
	}

	.el-dropdown-link {
		cursor: pointer;
		color: #000;
		font-size: 16px !important;
    line-height: 40px;
    border-right: 1px solid #ddd;
    padding-right: 20px;
	}

	.head_img {
		width: 35px;
		height: 35px !important;
		margin-right: 10px;
		border-radius: 100px;
	}

	.cont_col1 {
		margin-right: 20px;
	}

	.cont_col2 {
		color: #000;
    padding-right: 20px;
	}

	.navbar-brand img {
		width: 58px;
		height: 75px;
	}

	.cont_col1 img,
	.cont_col2 img {
		width: 20px;
		height: 20px;
	}

	.navbar-nav li a {
		height: 75px;
		text-align: center;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	@media screen and (max-width: 1680px) {
		.cont_login2 {
			width: 61% !important;
		}

		.cont_one {
			top: 138px !important;
		}

		.cont_day:nth-child(1) {
			// margin-left: 160px !important;
		}

		.cont_day {
			width: 55px !important;
		}

		.cont_qd {
			top: 20% !important;
		}

		.back_icon {
			height: 550px !important;
      width: 100%;
			position: fixed;
			top: 15%;
			margin: 0 auto;
			right: 0;
			left: 0;
		}

		.wrong1_icon {
			right: 30px !important;
		}
	}

	.cont_mb {
		width: 100%;
		background: #333;
		opacity: 0.4;
		position: fixed;
		top: 0;
		z-index: 2;
	}

	.cont_login2 {
		margin: 0 auto;
		background: none;
		top: 20%;
		left: 0px;
		right: 0px;
		padding: 30px;
		position: fixed;
		z-index: 4;
		border-radius: 30px;

		.cont_line {
			width: 1px;
			height: 315px;
			background: #999;
		}

		.cont_text {
			width: 100%;
			padding: 10px 20px;

			h4 {
				margin-bottom: 30px;
			}

			.wrong_icon {
				width: 20px;
				height: 20px;
				position: absolute;
				top: 26px;
				right: 36px;
				z-index: 3;
			}

			.cont_inp {
				width: 80%;
				padding: 10px;
				margin: 10px;
				background: #e4e4e4;
				border: 1px solid #e4e4e4;
				border-radius: 10px;
			}

			.cont_inp1 {
				width: 80%;
				padding: 10px;
				background: #e4e4e4;
				border: 1px solid #e4e4e4;
				border-radius: 10px;
			}

			.cont_yanzeng {
				width: 100%;
				margin: 10px;
				position: relative;

				.cont_col3 {
					padding: 1px 10px;
					color: #e3130b;
					font-size: 10px;
					border: 1px solid #e3130b;
					border-radius: 100px;
					position: absolute;
					right: 15%;
				}
			}

			.cont_log {
				width: 80%;
				padding: 10px;
				margin: 10px;
				color: #fff;
				cursor: pointer;
				font-size: 16px;
				border-radius: 100px;
				background: #a60e0a;
			}

			.cont_xugai {
				font-size: 12px;
				margin-top: 5px;
				color: #a60e0a;
			}

			.cont_line1 {
				width: 50px;
				background: #999;
				height: 1px;
			}

			.cont_phon_login {
				font-size: 14px;
				margin: 10px;
				color: #999;
			}

			.dui_icon {
				width: 140px;
				height: 140px;
			}
		}

		.wrong1_icon {
			width: 20px;
			height: 20px;
			position: absolute;
			top: 30px;
			right: 30px;
			z-index: 3;
		}

		.back_icon {
			position: absolute;
			top: 0;
      width: 100%;
			margin: 0 auto;
			right: 0;
			left: 0;
		}

		.cont_box1 {
			padding: 3px 12px;
			border-radius: 100px;
			font-weight: 600;
			// background: #fff;
			letter-spacing: 4px;
		}

		.cont_qd {
			position: absolute;
			top: 25%;
			left: 0;
			right: 0;
			width: 287px;
			margin: 0 auto;
		}

		.cont_one {
			width: 800px;
			flex-wrap: wrap;
			position: relative;
			left: 5px;
			right: 5px;
			top: 220px;

			.cont_day:nth-child(1) {
				// margin-left: 160px;
			}

			.cont_day {
				margin: 10px 10px 10px 13px;
				width: 60px;
				font-size: 8px;
				color: #333;
				background: #e4e4e4;
				/*background: #A60E0A;*/
				border-radius: 6px;

				.duihao_icon,
				.xing_icon {
					width: 20px;
					height: 20px;
					margin: 2px 0;
				}
			}
		}
	}

	.style1 {
		float: left;
		font-size: 22px;
		color: #000!important;
		font-weight: bolder;
		line-height: 58px;
	}

	.style2 {
		float: right;
		font-size: 20px;
		margin: 0px 50px 0px 0px;
		color: dimgray;
		height: 85px;
		line-height: 85px;
	}

	.style3 {
		float: left;
		margin: 10px 0 10px 20px;
		height: 65px;
	}

	.style3 img {
		max-height: 65px;
		min-height: 65px;
	}
</style>



// WEBPACK FOOTER //
// src/components/Head.vue